<template>
  <div class="table-page">
    <div class="loading loading-lg mt-2" v-if="loading" />
    <template v-else>
      <div class="empty mt-2" v-if="expenses.length === 0">
        <div class="empty-icon">
          <fa-icon :icon="['fal', 'info-circle']" size="2x"/>
        </div>
        <p class="empty-title h5">Exceções</p>
        <p class="empty-subtitle">Nenhuma exceção cadastrada para este profissional</p>
        <div class="action">
          <button class="btn btn-secondary btn-icon btn-icon-left mt-2"
                  @click="addExpense">
            <fa-icon :icon="['fal', 'plus']"/>Adicionar exceção
          </button>
        </div>
      </div>
      <div v-else>
        <div class="stenci-group stenci-alert text-center">
          <h6 class="stenci-title text-secondary">
            Serviços com exceções
          </h6>

          <div class="form-group">
            Inclua apenas os serviços em que o profissional possua condições
            ou valores diferenciados. Quando as regras e valores forem os mesmos
            praticados pelos demais profissionais, esse cadastro é dispensável.
          </div>

          <div class="form-group">
            Apenas serviços vinculados a tabelas de preços serão exibidos nos resultados de busca.
          </div>

          <div class="mb-1">
            <button class="btn btn-icon btn-icon-left btn-primary"
                    @click="addExpense">
              <fa-icon :icon="['fal', 'plus']" />Adicionar serviço
            </button>
          </div>
        </div>
        <div class="stenci-group" v-for="(item, i) in expenses" :key="item.key">
          <div class="columns">
            <div class="column centered">
              <span class="stenci-title text-primary" v-if="item?.expense?.id">
                {{ item.expense.name }}
              </span>
              <div v-else>
                <dx-autocomplete
                  id="family-name"
                  :source="findExpenses"
                  v-model="item.expense"
                  label="name"
                  track-by="id"
                  :debounce="600"
                  placeholder="Nome do serviço (consulta, procedimento, exame...)"
                >
                  <template v-slot:action>
                    <button
                      class="btn btn-action input-group-btn btn-icon btn-neutral"
                      tabindex="-1">
                      <fa-icon :icon="['fal', 'search']" />
                    </button>
                  </template>
                  <template v-slot="{ item }">
                    <div>{{ item.name }}</div>
                  </template>
                </dx-autocomplete>
              </div>
            </div>
            <div class="column centered text-right">
              <button class="btn btn-icon btn-icon-left btn-secondary btn-sm mr-1"
                      v-if="item?.expense?.id"
                      :disabled="deleting || (saving && idx === i)"
                      @click="addExpenseTable(item.expense.id)">
                <fa-icon :icon="['fal', 'plus']" />Adicionar Exceção
              </button>
              <button class="btn btn-icon btn-icon-left btn-neutral btn-sm"
                      v-if="item.tables.length === 0"
                      :disabled="deleting"
                      @click="removeExpense(item)">
                <fa-icon :icon="['fal', 'times']" />Remover
              </button>
            </div>
          </div>
          <template v-if="item?.expense?.id">
            <div class="loading loading-lg" v-if="saving && idx === i" />
            <template v-else>
              <div class="empty mt-2" v-if="item.tables.length === 0">
                <p class="empty-title h5">Exceções</p>
                <p class="empty-subtitle">Nenhuma exceção adicionada.</p>
              </div>
              <template v-else>
                <div class="divider" />
                <table class="table table-hover">
                  <thead>
                  <tr>
                    <th>Tabela de preço</th>
                    <th class="text-right" style="width: 70px">
                      Cred.
                      <span class="c-hand tooltip tooltip-left"
                            data-tooltip="Recebimento direto com o profissional">
                      <fa-icon
                        class="text-info"
                        :icon="['fal', 'info-circle']"
                      />
                    </span>
                    </th>
                    <th class="text-right" style="width: 120px">
                      Taxa (%)
                      <span class="c-hand tooltip tooltip-left"
                            data-tooltip="PJ: Taxa da clínica | PF: taxa do profissional">
                      <fa-icon
                        class="text-info"
                        :icon="['fal', 'info-circle']"
                      />
                    </span>
                    </th>
                    <th class="text-right" style="width: 120px">Valor plano</th>
                    <th class="text-right" style="width: 120px">Valor particular</th>
                    <th class="text-right" style="width: 140px">Valor repasse</th>
                    <th class="text-right" style="width: 40px"></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(table, i) in item.tables" :key="table.id">
                    <td>
                      {{ table.name }}
                    </td>
                    <td>
                      <select class="form-select select-sm"
                              @change="save(item.expense.id, table)"
                              v-model="table.definition.accredited">
                        <option value="pf">Sim</option>
                        <option value="pj">Não</option>
                      </select>
                    </td>
                    <td class="text-right">
                      <div class="input-group">
                        <dx-input-number
                          class="form-input input-sm"
                          @change="save(item.expense.id, table)"
                          v-model="table.definition.taxValue"
                          :precision="2"
                          maxlength="6"
                        />
                        <select class="form-select select-sm"
                                style="max-width: 2.3rem; background-color: #f8f9fa"
                                @change="save(item.expense.id, table)"
                                v-model="table.definition.taxType"
                                v-if="table.definition.accredited === 'pf'">
                          <option value="pf">PF</option>
                          <option value="pj">PJ</option>
                        </select>
                      </div>
                    </td>
                    <td class="text-right">
                      <dx-input-number
                        class="form-input input-sm"
                        v-model="table.definition.insuranceValue"
                        @change="save(item.expense.id, table)"
                        :precision="2"
                      />
                    </td>
                    <td class="text-right">
                      <dx-input-number
                        class="form-input input-sm"
                        v-model="table.definition.particularValue"
                        @change="save(item.expense.id, table)"
                        :precision="2"
                      />
                    </td>
                    <td class="text-right">
                      <div class="input-group">
                        <dx-input-number
                          class="form-input input-sm"
                          v-model="table.definition.transferValue"
                          @change="save(item.expense.id, table)"
                          :precision="2"
                          maxlength="7"
                        />
                        <select
                          class="form-select select-sm"
                          v-model="table.definition.transferType"
                          @change="save(item.expense.id, table)"
                          style="max-width: 2.5rem; background-color: #f8f9fa">
                          <option value="percent">%</option>
                          <option value="value">R$</option>
                        </select>
                      </div>
                    </td>
                    <td class="text-right">
                      <button
                        class="btn btn-sm btn-action btn-icon btn-error"
                        :class="{loading: deleting && idx === i}"
                        :disabled="deleting"
                        @click="removeExpenseTable(item.expense.id, table)">
                        <fa-icon :icon="['fal', 'times']" />
                      </button>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <div class="text-small text-bold mt-2 text-warning">
                  * Valores e regras personalizados para o profissional
                </div>
              </template>
            </template>
          </template>
        </div>
      </div>
    </template>

    <find-table-modal
      v-if="findTableModal.show"
      :expense-id="findTableModal.expenseId"
      @selected="selectedTables"
      @close="findTableModal.show = false"
    />
  </div>
</template>

<script>
import FindTableModal from '@/app/expense-table/components/modals/FindTableModal.vue';
import { randomHash } from '@/helpers';

export default {
  components: { FindTableModal },
  props: {
    professionalId: {
      type: String,
    },
  },
  data() {
    return {
      idx: null,
      loading: false,
      saving: false,
      deleting: false,
      findTableModal: {
        expenseId: null,
        show: false,
      },
      expenses: [],
    };
  },
  watch: {
    professionalId(value) {
      if (value) {
        this.load();
      }
    },
  },
  mounted() {
    if (this.professionalId) {
      this.load();
    }
  },
  methods: {
    load() {
      this.loading = true;

      this.$http.get(`/professionals/${this.professionalId}/tables`)
        .then(({ data }) => {
          this.expenses = data.items;
        })
        .catch(() => {})
        .then(() => {
          this.loading = false;
        });
    },
    addExpense() {
      this.expenses.unshift({
        id: null,
        key: randomHash(),
        expense: null,
        tables: [],
      });
    },
    removeExpense(item) {
      const idx = this.expenses.findIndex(({ expense }) => expense?.id === item?.expense?.id);
      if (idx >= 0) this.expenses.splice(idx, 1);
    },
    findExpenses(search) {
      const params = {
        active: true,
        search,
      };

      const expenseIds = this.expenses
        .filter(item => item.expense)
        .map(({ expense }) => expense?.id)
        .filter(Boolean);

      return this.$httpX.get('/expenses', { params })
        .then(({ data }) => {
          const items = (data.items || []).filter(item => !expenseIds.includes(item.id));

          if (items.length === 0) {
            return [{ id: null, name: 'Serviço não encontrado!' }];
          }

          return items.map(item => ({
            id: item.id,
            name: item.name,
          }));
        });
    },
    addExpenseTable(id) {
      this.findTableModal.expenseId = id;
      this.findTableModal.show = true;
    },
    save(expenseId, table) {
      const data = {
        accredited: table.definition.accredited || 'pj',
        taxValue: table.definition.taxValue || 0,
        taxType: table.definition.taxType || 'pj',
        particularValue: table.definition.particularValue,
        insuranceValue: table.definition.insuranceValue,
        transferValue: table.definition.transferValue,
        transferType: table.definition.transferType,
      };

      return this.$http
        .put(`/professionals/${this.professionalId}/expenses/${expenseId}/tables/${table.id}`, data)
        .catch(() => {
          this.$toast.error('Erro ao salvar os dados!');
        });
    },
    selectedTables(tables) {
      if (this.saving || this.deleting) {
        return null;
      }

      const { expenseId } = this.findTableModal;
      const foundExpense = this.expenses.find(({ expense }) => expense?.id === expenseId);
      this.idx = this.expenses.indexOf(foundExpense);

      this.saving = true;

      const savedTableIds = foundExpense.tables.map(({ id }) => id);
      tables = tables.filter(item => item.id && !savedTableIds.includes(item.id));

      this.findTableModal.show = false;
      this.findTableModal.expenseId = null;

      if (tables.length === 0) {
        this.saving = false;
        return null;
      }

      const data = {
        tables: tables.map(table => ({
          id: table.id,
          name: table.name,
          definition: {
            accredited: 'pj',
            taxValue: 0,
            taxType: 'pj',
            insuranceValue: table.definition.insuranceValue ?? 0,
            particularValue: table.definition.particularValue ?? 0,
            transferValue: table.definition.transferValue ?? 0,
            transferType: table.definition.transferType ?? 'percent',
          },
        })),
      };

      return this.$http
        .post(`/professionals/${this.professionalId}/expenses/${expenseId}/tables`, data)
        .then(() => {
          tables.forEach((table) => {
            const exp = table?.expenses;
            const def = exp?.definition || {};

            foundExpense.tables.push({
              id: table.id,
              name: table.name,
              definition: {
                accredited: 'pj',
                taxValue: 0,
                taxType: 'pj',
                insuranceValue: def.insuranceValue ?? 0,
                particularValue: def.particularValue ?? 0,
                transferValue: def.transferValue ?? 0,
                transferType: def.transferType ?? 'percent',
              },
            });
          });
          this.$toast.success('Tabelas adicionadas com sucesso!');
        })
        .catch(() => {
          this.$toast.error('Erro ao carregar os dados!');
        }).finally(() => {
          this.saving = false;
        });
    },
    removeExpenseTable(expenseId, table) {
      if (this.deleting) {
        return;
      }

      this.$dialog.show('', {
        html:
          '<div class="text-center">'
          + '<h5 class="text-center">Atenção!</h5>'
          + '<div>Deseja realmente excluir este registro?</div>'
          + '</div>',
        buttons: [
          {
            label: 'Não',
            classes: '',
          }, {
            label: 'Sim',
            classes: 'btn-primary btn-error ml-2',
            click: (close) => {
              close();
              const foundExpense = this.expenses.find(({ expense }) => expense.id === expenseId);
              this.idx = foundExpense.tables.indexOf(table);
              this.deleting = true;
              const profId = this.professionalId;
              this.$http
                .delete(`/professionals/${profId}/expenses/${expenseId}/tables/${table.id}`)
                .then(() => {
                  foundExpense.tables.splice(this.idx, 1);
                  if (foundExpense.tables.length === 0) {
                    this.removeExpense(foundExpense);
                  }
                })
                .catch(() => {
                  this.$toast.show('Ocorreu um erro. Tente novamente!', { type: 'error' });
                })
                .finally(() => {
                  this.deleting = false;
                });
            },
          },
        ],
      });
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables.scss";

.table-page {
  .stenci-group {
    margin-bottom: $layout-spacing-lg;
    .empty {
      border: $border-width solid $border-color;
      padding: $layout-spacing 0;
    }
  }
}
</style>
